<template>
	<div>
		<div class="box box_login">
			<label>
				{{ $t('global.select_lang') }}
			</label>
			<e-select
			track-by="iso"
			label="name"
			:options="all_langs"
			:searchable="true"
			:allow-empty="false"
			:show-labels="false"
			:search="true"
			v-model="lang"
			@input="setLangue"
			>
			<template slot="singleLabel" slot-scope="{ option }">
				<img v-if="option.iso" :src="require(`GroomyRoot/assets/img/flag-iso/${option.iso}.png`)" style="height:16px;">
				<span class="ml-2">{{ option.name }}</span>
			</template>
			<template slot="option" slot-scope="props">
				<img v-if="props.option.iso" :src="require(`GroomyRoot/assets/img/flag-iso/${props.option.iso}.png`)" style="height:16px;">
				<span class="ml-2">{{ props.option.name }}</span>
			</template>
			<template slot="noOptions">{{ $t('global.list_empty') }}</template>
		</e-select>
	</div>
</div>	
</template>

<script type="text/javascript">
import Vue from 'vue'
import Config from '@/mixins/Config.js'
import { loadI18nPlugin } from 'GroomyRoot/assets/js/i18n.js'

export default {
	name: 'ChoixCountry',
	mixins: [Config],
	props: {
		pax_express: {
			type: Boolean,
			default: () => false
		}
	},
	data () {
		return {
			all_langs: [
			{iso: 'FR', name: 'Français'},
			{iso: 'EN', name: 'English'}
			],
			lang: null,
		}
	},
	mounted() {
		this.init_component()
	},
	methods: {
		init_component() {
			this.lang = this.all_langs.find(country => country.iso == Vue.i18n.locale().toUpperCase())
		},
		
		setLangue(lang) {
			this.setConfig('lang', lang.iso.toLowerCase())
			loadI18nPlugin(lang.iso.toLowerCase())
			this.$emit('language-changed', lang.iso.toLowerCase())
		}
	}
}

</script>